import { HOST, DEBUG_MODE } from './config'
import {
  isNumeric,
  dateToNetDate,
  isNotNullOrEmptyString,
  TO_TRIMMED_STRING_FUNCTION,
  IS_NOT_NULL_OR_UNDEFINED_FUNCTION,
  IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION,
} from './misc'

export function canPlaylistAndFave(
  web2UserLoggedIn: any,
  userSubscribed: boolean,
) {
  let ret: boolean = false
  try {
    ret = web2UserLoggedIn && userSubscribed
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const UPSERT_OR_DELETE_FAVORITE_CALLSTRING: string[] = [
  TO_TRIMMED_STRING_FUNCTION +
    IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION +
    IS_NOT_NULL_OR_UNDEFINED_FUNCTION +
    `self.addEventListener('message', async (event) => {
      if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
          try {
            if (
              isNotNullOrEmptyString(event?.data?.token_id) &&
              isNotNullOrEmptyString(event?.data?.contract_address) &&
              isNotNullOrEmptyString(event?.data?.web2UserId) &&
              isNotNullOrUndefined(event?.data?.addFavorite)
            ) {
              const urlencoded = new URLSearchParams({
                favoriteData: JSON.stringify({
                  tokenId: toTrimmedString(event?.data?.token_id),
                  contractAddress: toTrimmedString(event?.data?.contract_address),
                  add_favorite: event?.data?.addFavorite,
                  web2UserId: toTrimmedString(event?.data?.web2UserId),
                }),
              })
              const opts = {
                method: 'POST',
                body: urlencoded,
              }
              const resp = await fetch('${HOST}' + '/api/p.stream-sv/f/pf2', opts)
              await resp
                .json()
                .then((respon) =>
                  self.postMessage(respon?.success ? respon?.success : false)
                )
                .catch((er) => {
                  if (${DEBUG_MODE}) console.log(er)
                  self.postMessage(false)
                })
            } else resolve(false)
          } catch (e) {
            if (${DEBUG_MODE}) console.log(e)
              self.postMessage(false)
          }
      }
  })
`,
]

export const GET_FAVORITES_CALLSTRING: string[] = [
  `self.addEventListener('message', async (event) => {
        if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
        try {
          const opts = {
            method: 'POST',
            body: JSON.stringify({
              walletAddress: '',
              web2UserId: event.data,
            }),
          }
          await fetch('${HOST}/api/p.stream-sv/f/gfs', opts)
            .then(async (x) => {
              const ret = await x.json()
              self.postMessage(ret?.favorites?.length > 0 ? ret?.favorites : [])
            })
            .catch((e) => {
              if (${DEBUG_MODE}) console.log(e)
              self.postMessage([])
            })
          } catch (ez) {
            if (${DEBUG_MODE}) console.log(ez)
            self.postMessage([])
          }
        } else self.postMessage([])
    })`,
]

export function getCreatedDate(favorite: any) {
  let ret: any = null
  try {
    ret = isNotNullOrEmptyString(favorite?.updated)
      ? isNumeric(favorite?.updated)
        ? Date.parse(
            new Date(parseInt(favorite?.updated?.toString().trim() + '000'))
              .toString()
              .trim(),
          )
        : Date.parse(dateToNetDate(favorite?.updated))
      : isNotNullOrEmptyString(favorite?.created)
        ? isNumeric(favorite?.created)
          ? Date.parse(
              new Date(parseInt(favorite?.created?.toString().trim() + '000'))
                .toString()
                .trim(),
            )
          : Date.parse(dateToNetDate(favorite?.created))
        : null
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const MERGE_FAVORITES_WITH_SONGS_FUNCTION_STRING: string[] = [
  TO_TRIMMED_STRING_FUNCTION +
    `
  self.addEventListener('message', (event) => {
      const data = event?.data;
      if (!data?.songs || !data?.favorites) {
          const json = JSON.stringify({ songs: data?.songs || [], favorites: data?.favorites || [], success: true });
          self.postMessage({ respData: new TextEncoder().encode(json).buffer });
          return;
      }
      try {
          const songs = data.songs;
          const favorites = data.favorites;
          const favMap = new Map();
          for (let i = 0; i < favorites.length; i++) {
              const f = favorites[i];
              favMap.set(\`\${f.contractAddress}_\${f.tokenId}\`, f);
          }
          const songMap = new Map();
          for (let i = 0; i < songs.length; i++) {
              const s = songs[i];
              const key = \`\${s.contract_address}_\${s.token_id}\`;
              s.favorited = favMap.has(key);
              songMap.set(key, s);
          }
          const retFavorites = [];
          for (let i = 0; i < favorites.length; i++) {
              const f = favorites[i];
              const matchedSong = songMap.get(\`\${f.contractAddress}_\${f.tokenId}\`);
              if (matchedSong) {
                  retFavorites.push({
                      animation_url: matchedSong.animation_url,
                      contract_address: matchedSong.contract_address,
                      token_id: matchedSong.token_id,
                      artist: matchedSong.artist,
                      duration: matchedSong.duration,
                      formattedDuration: matchedSong.formattedDuration,
                      formattedMintDate: matchedSong.formattedMintDate,
                      genres: matchedSong.genres,
                      frontImage: matchedSong.frontImage,
                      name: matchedSong.formattedSongNameBigger,
                      formattedSongNameSmallSpaceEscaped: matchedSong.formattedSongNameSmallSpaceEscaped,
                      formattedSongNameBig: matchedSong.formattedSongNameBig,
                      formattedSongNameBigger: matchedSong.formattedSongNameBigger,
                      formattedArtistNameBig: matchedSong.formattedArtistNameBig,
                      formattedArtistNameBigger: matchedSong.formattedArtistNameBigger,
                      rawName: matchedSong.name,
                      favorited: true,
                      created: f.created,
                      updated: f.updated,
                      deleted: f.deleted,
                      keyOne: matchedSong.keyOne,
                      keyTwo: matchedSong.keyTwo,
                      keyThree: matchedSong.keyThree,
                  });
              }
          }
          const jsonString = JSON.stringify({ songs: songs, favorites: retFavorites, success: true });
          self.postMessage({ respData: new TextEncoder().encode(jsonString).buffer });

      } catch (e) {
          if (${DEBUG_MODE}) console.log(e);
          const errJson = JSON.stringify({ songs: data.songs, favorites: data.favorites, success: false });
          self.postMessage({ respData: new TextEncoder().encode(errJson).buffer });
      }
  });
`,
]

export function mergeFavoritesWithSongs(songs: any[], favorites: any[]) {
  if (!songs || songs.length === 0) return []
  try {
    const favoriteKeys = new Set(
      favorites?.map((f) => `${f.contractAddress}_${f.tokenId}`),
    )
    for (let i = 0; i < songs.length; i++) {
      const s = songs[i]
      const compositeKey = `${s.contract_address}_${s.token_id}`
      s.favorited = favoriteKeys.has(compositeKey)
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return songs
}
